/* istanbul ignore file */

export interface AmplifyError extends Error {
    code: string;
}
